import React, { useState, useEffect } from "react";
import { Box, Container, makeStyles, Typography } from "@material-ui/core";
import Page from "src/components/Page";
import Form from "./Form";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import {
  apiEndpoints,
  apiGetByIdRequest,
  apiPutRequest,
} from "src/utils/api/api";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import KmPageTitle from "src/components/layout/KmPageTitle";
import { kmMessages } from "src/constant/Messages";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3),
  },
}));

const MailingEditForm = ({
  systemInfo,
  enableGlobalLoader,
  disableGlobalLoader,
  displaySnackbar,
  setLogoutUser,
  ...rest
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { entryId } = useParams();
  const [mailing, setMailing] = useState();
  const [formReady, setFormReady] = useState(false);

  let pageTitle = "Edycja powiadomienia";

  useEffect(() => {
    enableGlobalLoader();
    apiGetByIdRequest(apiEndpoints.getMailingPreviewDetails.path, entryId, true)
      .then((data) => {
        disableGlobalLoader();
        setMailing(data);
        setFormReady(true);
      })
      .catch((error) => {
        disableGlobalLoader();
      });
    setFormReady(true);
    return () => {};
  }, []);

  const onSubmit = (formValues, mailingId, content, mailingStatus) => {
    enableGlobalLoader();

    apiPutRequest(
      apiEndpoints.updateMailing.path,
      {
        id: mailingId,
        body: content,
        status: mailingStatus ? mailingStatus : null,
      },
      true
    )
      .then((data) => {
        disableGlobalLoader();
        // displaySnackbar({
        //   isOpen: true,
        //   severity: "success",
        //   autoHideDuration: 3000,
        //   message: "Zmiany zostały zapisane",
        // });
        navigate(`/powiadomienia`);
      })
      .catch((error) => {
        disableGlobalLoader();
        if (error.response && error.response.status === 401) {
          setLogoutUser();
        } else if (error.response.status === 500 && error.response.data) {
          // if (error.response.data.code === "MISSING_REQUIRED_FIELD_VALUE") {
          displaySnackbar({
            isOpen: true,
            severity: "error",
            autoHideDuration: 8000,
            message: kmMessages.error.global.genericerror,
          });
          // }
        }
      });
  };

  return (
    <Page className={classes.root} title={pageTitle}>
      <KmPageTitle>{pageTitle}</KmPageTitle>

      <Container maxWidth={false}>
        <Box mt={3}>
          <Form systemInfo={systemInfo} onSubmit={onSubmit} mailing={mailing} />
        </Box>
      </Container>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  systemInfo: state.globalData.systemInfo,
});

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  setLogoutUser: () => dispatch(actions.setLogoutUser()),
  displaySnackbar: (snackBarParameters) =>
    dispatch(actions.displaySnackbar(snackBarParameters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MailingEditForm);
